import React from 'react';
import { Link } from 'react-router-dom';
import '../css-coding/CSIntro.css';
import CS1 from '../assets/CS1.png';
import CS2 from '../assets/CS2.png';



const CSIntro = () => {
  const blogs = [
    {
      id: 1,
      title:
        "How We Helped Rajees Makeover Gain 24,000 Organic Followers in Just 1.5 Months",
     
      tag: "Case Study 1",
      image: CS1,
      link: "/casestudy1",
      readTime: "9 Min read",
    },
    {
      id: 2,
      title: "How We Helped BBQ Mechanic Gain 9,000 Organic Followers in Just 2 Months",
     
      tag: "Case Study 2",
      image: CS2,
      link: "/casestudy2",
      readTime: "7 Min read",
    },
  
  ];

  return (
    <div className="blog-container-cs">
      <h1 className="blog-title-cs">Case Studies</h1>
      <p className="blog-subtitle-cs">
      Explore the latest selected case studies to understand our process
      </p>

      <br />
      <br />

      <div className="blog-grid-cs">
        {blogs.map((blog) => (
          <Link to={blog.link} className="blog-card-cs" key={blog.id}>
            <div className="blog-image-cs">
              <img src={blog.image} alt={blog.title} />
              <span className="blog-category-cs">{blog.tag}</span>
            </div>

            <div className="blog-content-cs">
              <h3 className="blog-heading-cs">{blog.title}</h3>
              <p className="blog-description-cs">{blog.description}</p>

              <div className="blog-footer-cs">
                <span className="blog-date-cs">
                  <span style={{ marginRight: '8px' }}></span>
                  {blog.readTime}
                </span>

                <Link to={blog.link} className="read-more-h-cs">
                  Read more →
                </Link>
              </div>

            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CSIntro;
